import { useEffect, useState } from "react"
import Form from 'react-bootstrap/Form'

import { Control, SettingsGroup } from "../../../Modules/General"

import FontModule from "../../../Modules/FontModule"
import VariableModule from "../../../Modules/VariableModule"

import * as Basic from "../../../Modules/BasicFields"

const kingOfTheHillVariables = [
    {name:'Output', key:'output', type:'W'},
    {name:'Top', key:'top', type:'W'}
]

export default function KingOfTheHill( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const selected = props.selected
    const reset = props.reset

    const [ hashtag, setHashtag ] = useState(null)
    const [ duration, setDuration ] = useState(null)
    const [ cooldown, setCooldown] = useState(null)

    const [ font, setFont ] = useState(null)
    const [ variables, setVariables ] = useState(null)

    const requiredData = [
        hashtag, 
        duration,
        cooldown,
        font,
        variables
    ]

    const cfgName = "kingmaker_king_of_the_hill_cfg"


    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setHashtag( cfg.hashtag || "" )  
        setDuration( (cfg.duration != null) ? cfg.duration : 300)
        setCooldown( (cfg.cooldown != null) ? cfg.cooldown : 30 )

        setFont( cfg.font || {})
        setVariables( cfg.variables || {})
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {
        if( requiredData.includes(null) )
        {
            return
        }

        let data = {}
        data.font = font 
        data.variables = variables

        data.hashtag = hashtag
        data.duration = duration
        data.cooldown = cooldown
       
        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ hashtag, duration, cooldown, font, variables ])

    if( requiredData.includes(null) )
    {
        return (<></>)
    }

    return (
        <>
            <SettingsGroup name="Behaviour"> 
                <Basic.StringInput name="Hashtag" value={hashtag} setValue={setHashtag}/>
                <Basic.PositiveIntegerInput name="Duration" value={duration} setValue={setDuration}/>
                <Basic.PositiveIntegerInput name="Cooldown" value={cooldown} setValue={setCooldown}/>
            </SettingsGroup>

            <FontModule font={font} 
                        setFont={setFont}
                        selected={selected}
                        reset={reset}
            />
            
            <VariableModule variables={variables} 
                            setVariables={setVariables} 
                            variableList={kingOfTheHillVariables}
                            reset={reset}
            />
        </>
    )
}


